import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ErrorHandler from 'common/error/components/error-handler';
import Dashboard from '../components/dashboard';
import { fetchDashboard, saveNotes, fetchNotes, dashboardSuccess } from './dashboard-actions';

import {
  getEquipmentsTableData,
  getKPIs,
  getShortTermTimeline,
  getInstalledAtsTableData,
  getServicesTableData,
  getContactsTableData,
} from './dashboard-selectors';

class DashboardContainer extends Component {
  // eslint-disable-line
  static propTypes = {
    id: PropTypes.string.isRequired,
    fetchDashboard: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    error: PropTypes.object,
    saveNotes: PropTypes.func.isRequired,
  };

  componentDidMount() {
    if (this.props.id) {
      this.fetchData({
        id: this.props.id,
        type: this.props.type,
      });
    }
  }

  componentWillReceiveProps = (nextProps) => {
    // TODO: check if this is not an anti-pattern
    // if there is a route change (new id),
    // refetch the data.
    if (nextProps.id && nextProps.id !== this.props.id) {
      this.fetchData({
        id: this.nextProps.id,
        type: this.nextProps.type,
      });
    }
  };

  fetchData = ({ id, type }) => {
    this.props.fetchDashboard({ id, type });
  };

  saveNotes = (notes) => {
    const { type, id } = this.props;
    this.props.saveNotes({ type, id, notes });
  };

  render() {
    const { error, ...rest } = this.props;
    return (
      <>
        <ErrorHandler type='notification' error={error} />
        <Dashboard {...rest} saveNotes={this.saveNotes} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  data: state.dashboard.data,
  equipmentsTableData: getEquipmentsTableData(state),
  functionalLocationsTableData: state.dashboard.data.functionalLocations,
  equipmentCount: state.dashboard.data.equipmentCount,
  notes: state.dashboard.data.notes || [],
  kpis: getKPIs(state),
  shortTermTimeline: getShortTermTimeline(state),
  installedAtsTableData: getInstalledAtsTableData(state),
  isLoading: state.dashboard.isLoading,
  isNotesLoading: state.dashboard.isNotesLoading,
  notesError: state.dashboard.notesError,
  error: state.dashboard.error,
  servicesTableData: getServicesTableData(state),
  contactsTableData: getContactsTableData(state),
  activeContext: state.navigation.activeContext,
  activeChilds: state.navigation.navigationChilds,
  activeParents: state.navigation.navigationParents,
  activeSelf: state.navigation.navigationSelf,
});

const mapDispatchToProps = {
  fetchDashboard,
  saveNotes,
  fetchNotes,
  dashboardSuccess,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardContainer);
